import React from 'react';
import styled from 'styled-components';
import Img from '../components/Img';
import OuterLink from '../components/OuterLink';
import {Container} from '../styles/Grids';
import {breakPoint} from '../styles/var';

// images
import img_title from '../assets/img/pc06-1.png';
import img_main_1 from '../assets/img/pc06-4-1.png';
import img_main_2 from '../assets/img/pc06-5-1.png';
import img_main_3 from '../assets/img/pc06-6-1.png';
import img_main_4 from '../assets/img/pc06-7-1.png';
import img_btn_more from '../assets/img/pc05-3.png';
import img_8 from '../assets/img/8.png';
import img_7 from '../assets/img/7.png';

const ContentStyles = styled.div`
  position: relative;
  z-index: 1;
  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 20rem;
    background-image: linear-gradient(6deg, var(--white) 50%, var(--secondary) 0%);
    margin-bottom: -10rem;
  }
  .container {
    padding: 8rem 4rem 14rem;
    
    > .title {
      margin-bottom: 2rem;
    }
  }

  .fixed-img {
    position: absolute;
  }

  .img-7 {
    top: 38%;
    right: 10%;
    width: 183px;
  }

  .img-8 {
    bottom: -1%;
    left: 30%;
    transform: translateY(50%);
    width: 280px;
  }

  

  @media (min-width: ${breakPoint.min}) {
    .container {
      > .title {
        width: 80%;
        margin-right: auto;
        margin-left: auto;
        margin-bottom: 6rem;
      }
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    &::before {
      margin-top: -3rem;
      margin-bottom: -8rem;
      height: 10rem;
    }

    .container {
      padding: 3rem 2rem 6rem;

      > .desc {
        width: 100%;
        margin-bottom: 2rem;

        > p {
          top: 14%;
          right: 0;
          width: 50%;
        }
      }
    }
    .img-7 {
      top: 24%;
      width: 60px;
    }

    .img-8 {
      bottom: -1%;
      left: 30%;
      transform: translateY(50%);
      width: 100px;
    }
  }
`;
const WrapStyles = styled.div`
  margin-bottom: 6rem;
  .tag {
    background-color: var(--secondary);
    letter-spacing: 3px;
    padding-right: 2rem;
    padding-left: 2rem;
    margin-bottom: 1rem;
  }
  .btn-group {
    display: flex;
    gap: 2rem;
  }
  .content-inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 4rem;
  }
  @media (min-width: ${breakPoint.min}) {
    > .tag {
      font-size: 4rem;
      margin-bottom: 2rem;
    }

    > .title {
      font-size: 4rem;
    }
    .content-inner {
      width: 60%;
      margin-bottom: 6rem;
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    .content-inner {
      width: 80%;
    }
  }
`;


const Section5 = (props) => {
    return (
        <ContentStyles {...props}>
            <Img src={img_8} wrapProps={{className: 'fixed-img img-8'}}/>
            <Img src={img_7} wrapProps={{className: 'fixed-img img-7'}}/>
            <Container className="container">
                <Img src={img_title} wrapProps={{className: 'title'}}/>
                <WrapStyles>
                    <div className="content-inner">
                        <h3 className={"tag"}>風象星座</h3>
                        <h3 className={"title"}>風象星座媽媽的風格育兒術、最速配寶寶星座分析！（雙子、天秤、水瓶）</h3>
                        <p>擁有風一樣的敏捷思緒，柔軟又不失理性，總有源源不絕的想法與創意。隨著孩子年齡增長，風象星座媽咪更容易成為他們的朋友，因為此時能與孩子有更多意見的交流。</p>
                        <div className="btn-group">
                            <OuterLink href={'https://www.mombaby.com.tw/articles/9918746'} className={'btn'}>
                                <Img src={img_btn_more}/>
                            </OuterLink>
                        </div>
                    </div>
                    <Img src={img_main_1}/>
                </WrapStyles>
                <WrapStyles>
                    <div className="content-inner">
                        <h3 className={"tag"}>水象星座</h3>
                        <h3 className={"title"}>水象星座媽媽的風格育兒術、最速配寶寶星座分析！（巨蟹、天蠍、雙魚）</h3>
                        <p>水象星座媽咪的柔情似水，最大的優點是給予孩子無微不至的關愛，喜歡被孩子信任與依賴的感覺。關係緊密的人，只要一句尖銳的批評或指責，就會讓水象媽咪玻璃心碎滿地。</p>
                        <div className="btn-group">
                            <OuterLink href={'https://www.mombaby.com.tw/articles/9918752'} className={'btn'}>
                                <Img src={img_btn_more}/>
                            </OuterLink>
                        </div>
                    </div>
                    <Img src={img_main_2}/>
                </WrapStyles>
                <WrapStyles>
                    <div className="content-inner">
                        <h3 className={"tag"}>火象星座</h3>
                        <h3 className={"title"}>火象星座媽媽的風格育兒術、最速配寶寶星座分析！（牡羊、獅子、射手）</h3>
                        <p>如同閃爍在黑夜裡的火光，她們有主見、活力四射，常擔任起領導者的角色，接送、三餐樣樣自己來，工作育兒一把罩！看似強勢的火象媽咪，興致一來誰都擋不住，甚至玩得比孩子還瘋狂。</p>
                        <div className="btn-group">
                            <OuterLink href={'https://www.mombaby.com.tw/articles/9918633'} className={'btn'}>
                                <Img src={img_btn_more}/>
                            </OuterLink>
                        </div>
                    </div>
                    <Img src={img_main_3}/>
                </WrapStyles>
                <WrapStyles>
                    <div className="content-inner">
                        <h3 className={"tag"}>土象星座</h3>
                        <h3 className={"title"}>土象星座媽媽的風格育兒術、最速配寶寶星座分析！（金牛、處女、摩羯）</h3>
                        <p>喜歡穩定生活的土象星座媽咪，遇到任何情況，總會想辦法將未知數降到最低。對土象媽咪而言，「看得到的」才是真的，把孩子養得白白胖胖，就是她們最實在的「戰績」。</p>
                        <div className="btn-group">
                            <OuterLink href={'https://www.mombaby.com.tw/articles/9918679'} className={'btn'}>
                                <Img src={img_btn_more}/>
                            </OuterLink>
                        </div>
                    </div>
                    <Img src={img_main_4 }/>
                </WrapStyles>
            </Container>
        </ContentStyles>
    )
};

export default Section5;
